//@vendors
const { createActions } = require('redux-actions');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

const simpleActions = createActions(
    'VALIDATE_BLOCKED_ACCOUNT_REQUEST',
    'VALIDATE_BLOCKED_ACCOUNT_SUCCESS',
    'VALIDATE_BLOCKED_ACCOUNT_FAILURE'
);

const validateBlockedAccount = () => (dispatch, getState) => {
    const accountsById = getState().accounts.get('byId');
    const contracto = accountsById.map(account => {
        return { numerodecontrato: account.get("newContractNumber"), producto: account.get("newProduct")}
    });

    const requestData = {
        query : {
            accounts: Object.values(contracto.toJS())
        }
    };

    const isAccountBlockedValidationSuccess = getState().hiringProductBanners.get('isAccountBlockedValidationSuccess');
    if (!isAccountBlockedValidationSuccess) {

    dispatch(simpleActions.validateBlockedAccountRequest());
    return APIPost({
        dispatch,
        endpoint: 'validateBlockedAccount',
        params: requestData
    })
    .then(() => {
        dispatch(simpleActions.validateBlockedAccountSuccess())})
        
    .catch(response => {
        if (!!response.error) {
            dispatch(simpleActions.validateBlockedAccountFailure(response.error));
        } else {
            throw response;
        }
    });
    }
}


module.exports = {
    simpleActions,
    validateBlockedAccount
}
